
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const token = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
    if (token) {
      const decodedToken = jwtDecode(token);
      
      // Check if the token has expired
      if (decodedToken.exp < Date.now() / 1000) {
        // Token has expired, clear the storage and set user to null
        sessionStorage.clear();
        localStorage.clear();
        setUser(null);
        navigate('/login'); // Optionally navigate to login page
      } else {
        // If token is valid, retrieve the user data from localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          setUser(JSON.parse(storedUser));
          // Save the valid token back to sessionStorage for session persistence
          sessionStorage.setItem('userToken', token);
        } else {
          setUser(null);
        }
      }
    } else {
      setUser(null); // No token found, set user to null
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.clear(); // Clear session storage
    localStorage.clear(); // Clear local storage
    navigate('/'); // Redirect to home page
    window.location.reload(); // Reload the page to ensure state is fully reset
  };

  return (
    <div>
      <header className="bg-[#DEECFF] shadow">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <a href='/'>
            <div className="text-2xl font-bold text-gray-800">FBOOTH</div>
          </a>
          <nav className="flex space-x-4">
            <a href="/branches_list" className="text-gray-600 hover:text-blue-500">Branches</a>
            <a href="/booths_list" className="text-gray-600 hover:text-blue-500">Booths</a>
          </nav>
          <div className="space-x-4">
            {user ? (
              // If user is logged in, show profile and logout images
              <div className="flex space-x-4">
                <a href='/profile'>
                  <img 
                    src="https://www.shareicon.net/data/2017/04/19/884537_blue_512x512.png" 
                    alt="Profile" 
                    className="h-8 w-8 cursor-pointer"
                  />
                </a>
                <img 
                  src="https://cdn-icons-png.flaticon.com/512/7884/7884010.png" 
                  alt="Logout" 
                  className="h-8 w-8 cursor-pointer"
                  onClick={handleLogout}
                />
              </div>
            ) : (
              // If no user is logged in or token is expired, show sign up and log in buttons
              <div className="space-x-4">
                <a href='/register'>
                  <button className="bg-blue-500 text-white px-4 py-2 rounded-lg">Sign up</button>
                </a>
                <a href='/login'>
                  <button className="text-blue-500 border border-blue-500 px-4 py-2 rounded-lg">Log in</button>
                </a>
              </div>
            )}
          </div>
        </div>
      </header>
    </div>
  );
}
